import { FieldPattern } from '..';

import { PARAMS } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class ParamsField extends FormFieldWithInitialValue {
  readonly type: string = PARAMS;
  constructor(fieldData: FormFieldsType, initialValue: string | null = '') {
    super(fieldData, initialValue);
  }
  match<T>(p: FieldPattern<T>): T {
    return p.ParamsField(this);
  }
}
export default ParamsField;
